import { useAtomValue, useSetAtom } from 'jotai';
import {
  modalOpen,
  setIsEnterPhoneNumber,
  setIsValidateOtp,
  setIsVerificationSuccessful,
} from '../components/phone-number/states';

export function useEditPhoneNumberForm() {
  const open = useAtomValue(modalOpen);
  const setOpen = useSetAtom(modalOpen);
  const setSuccessfulVerificationContent = useSetAtom(setIsVerificationSuccessful);
  const setValidateOtpContent = useSetAtom(setIsValidateOtp);
  const setEnterPhoneNumberContent = useSetAtom(setIsEnterPhoneNumber);
  return {
    open,
    onClose: () => {
      setOpen(false);
      setTimeout(() => {
        setSuccessfulVerificationContent(false);
        setValidateOtpContent(false);
        setEnterPhoneNumberContent(false);
      }, 300);
    },
    onOpen: () => setOpen(true),
  };
}
